// Function to parse the name field from the meta block
export var parseMetaName = function (content) {
    var metaBlockRegex = /meta\s*{([^}]*)}/; // Matches the meta block
    var nameRegex = /name\s*=\s*"([^"]*)"/; // Matches the name field
    var metaBlockMatch = content.match(metaBlockRegex);
    if (metaBlockMatch) {
        var metaBlockContent = metaBlockMatch[1]; // Extract the content inside the meta block
        var nameMatch = metaBlockContent.match(nameRegex);
        if (nameMatch) {
            return nameMatch[1]; // Return the name value
        }
    }
    return null; // Return null if no name is found
};
// Function to parse the description field from the meta block
export var parseMetaDescription = function (content) {
    var metaBlockRegex = /meta\s*{([^}]*)}/; // Matches the meta block
    var descriptionRegex = /description\s*=\s*"([^"]*)"/; // Matches the description field
    var metaBlockMatch = content.match(metaBlockRegex);
    if (metaBlockMatch) {
        var metaBlockContent = metaBlockMatch[1]; // Extract the content inside the meta block
        var descriptionMatch = metaBlockContent.match(descriptionRegex);
        if (descriptionMatch) {
            return descriptionMatch[1]; // Return the description value
        }
    }
    return null; // Return null if no description is found
};
